<template>
  <v-content>
    <v-container class="login_page" fluid fill-height>
      <div class="login_page__background">
        <vue-particles color="#fff" linesColor="#1BC470" :particleOpacity="1" :lineOpacity="1"></vue-particles>
      </div>
      <v-layout align-center justify-center>
        <v-flex xs12 sm8 md4>
          <v-card class="elevation-12">
            <v-toolbar dark>
              <v-toolbar-title>Right.Link Space</v-toolbar-title>
            </v-toolbar>
            <v-card-text class="px-2">
              <v-text-field @keyup.enter="login" v-model="form.email" label="E-mail" :error-messages="errors && errors.email ? errors.email : []" required ></v-text-field>
              <v-text-field @keyup.enter="login" type='password' v-model="form.password" label="Password" :error-messages="errors && errors.password ? errors.password : []" required ></v-text-field>
            </v-card-text>
            <v-card-actions>
              <v-btn color="secondary" @click='login'>Sign in</v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </v-content>
</template>

<script>
  export default {
    name: 'LoginPage',
    data() {
      return {
        form: {
          email: '',
          password: ''
        },
        errors: {}
      }
    },
    methods: {
      login() {
        this.$store.dispatch('login', this.form).then(() => {
          let redirect = '/'
          this.$router.push(redirect)
        }, response => {
          this.errors = response.errors
        })
      }
    }
  }
</script>
